import React, { Component } from "react";

//IMPORT IMAGES
import firstImg from '../../frontend/assets/img/Jainism/first.png';
import secondImg from '../../frontend/assets/img/Jainism/2nd.png';
import thirdImg from '../../frontend/assets/img/Jainism/3rd.png';
import fourthImg from '../../frontend/assets/img/Jainism/4th.png';
import activityHQImg from '../../frontend/assets/img/Jainism/activityHQ.png';
import floatingIconsImg from '../../frontend/assets/img/Jainism/floating icons.png';
import star3Img from '../../frontend/assets/img/icon/star-3.png';
import boyflowerHQImg from '../../frontend/assets/img/Jainism/boyflowerHQ.png';
import Modal from "./Modal";
import { BASEURL } from "../../Global";

class Activity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gallaryData: [],
            currentIndex: 0,
            showModal: false
        };
    }

    async fetchGallary(value) {
        this.setState({ gallaryData: [], })
        try {
            await fetch(`${BASEURL}/searchandlistgallery`, {
                method: "POST",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    category: value
                })
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson.data) {
                                this.setState({ gallaryData: responseJson.data, })
                            } else {
                                this.setState({ gallaryData: [], })
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        this.setState({ gallaryData: [], })
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }

    handleImageClick = (index) => {
        this.setState({ currentIndex: index, showModal: true });
    }

    handleNextClick = () => {
        const { currentIndex } = this.state;
        const nextIndex = currentIndex === this.state.gallaryData.length - 1 ? 0 : currentIndex + 1;
        this.setState({ currentIndex: nextIndex });
    }

    handlePrevClick = () => {
        const { currentIndex } = this.state;
        const prevIndex = currentIndex === 0 ? this.state.gallaryData.length - 1 : currentIndex - 1;
        this.setState({ currentIndex: prevIndex });
    }

    handleCloseModal = () => {
        this.setState({ showModal: false });
    }

    componentDidMount() {
        this.fetchGallary("")
    }
    render() {
        return (
            <React.Fragment>
                <section className="classes-section space">
                    <div className="container">
                        <div className="row text-center justify-content-center wow fadeInUp" data-wow-delay="0.1s">
                            <div className="col-xl-6 col-lg-7 col-md-8 col-sm-9">
                                <div className="title-area">
                                    <span className="sub-title">Our Campus</span>
                                    <h2 className="sec-title">Amazing Activities Done By Our Kids</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row g-20 justify-content-center filter-active">
                            {this.state.gallaryData?.slice(0, 4).map((item, index) => (
                                <div key={index} className="col-xl-3 col-lg-4 col-sm-6 filter-item cat-1 wow fadeInUp" data-wow-delay="0.1s">
                                    <div className="project-card">
                                        <div className="project-img">
                                            <img src={item.image} alt="project-img" />
                                        </div>
                                        <a onClick={() => this.handleImageClick(index)} className="plus-btn popup-image">+</a>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {this.state.showModal && (
                            <Modal
                                imageUrl={this.state.gallaryData[this.state.currentIndex].image}
                                onNext={this.handleNextClick}
                                onPrev={this.handlePrevClick}
                                onCancel={this.handleCloseModal}
                            />
                        )}

                    </div>
                    <div className="shape-mockup shapePulse d-none d-xl-block activity-left" data-top="15%" data-left="7%" style={{ width: "10%" }}><img src={activityHQImg} alt="shapes" /></div>
                    <div className="shape-mockup shapePulse d-none d-hd-block z-index-negative" data-bottom="17%" data-left="7%" style={{ width: "6%", rotate: '60deg' }}><img src={floatingIconsImg} alt="shapes" /></div>
                    <div className="shape-mockup rotate z-index-negative" data-top="32%" data-right="9%"><img src={star3Img} alt="shapes" /></div>
                    <div className="shape-mockup shapePulse d-none d-hd-block activity-right" data-bottom="16%" data-right="2%" style={{ width: "10%" }}><img src={boyflowerHQImg} alt="shapes" /></div>
                </section>
            </React.Fragment >
        );
    }
}

export default Activity;
